import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function AppsPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedApp, setSelectedApp] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.title = 'Yapay Zeka Uygulamaları | Otel AI Asistan, OTA Ranker, Rakip Analizi, İtibar Yönetimi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Oteller için yapay zeka uygulamaları: WhatsApp AI Asistan, OTA Sıralama Takibi, Rakip Fiyat Analizi, Bölgesel Talep Tahmini, İtibar Yönetimi, Chatbot ve Sosyal Medya Yönetimi.');
    }
  }, []);

  const apps = [
    {
      icon: 'ri-robot-2-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Assistant',
      description: 'Misafirlerinizin WhatsApp üzerinden sorduğu tüm sorulara anında ve doğru yanıtlar veren, 132 dili destekleyen gelişmiş bir yapay zeka çözümüdür.',
      link: '/#contact',
      detailContent: {
        title: 'Yapay Zeka Assistant',
        description: 'Yapay Zeka Assistant, misafirlerinizin WhatsApp üzerinden sorduğu tüm sorulara anında ve doğru yanıtlar veren, 132 dili destekleyen gelişmiş bir yapay zeka çözümüdür. Resepsiyon yükünü azaltır, misafir memnuniyetini zirveye taşır.',
        features: [
          '132 Dilde Anında Yanıt',
          'WhatsApp Entegrasyonu', 
          '7/24 Kesintisiz Hizmet',
          'Otomatik Check-in/Check-out Bilgilendirmesi',
          'Oda Servisi ve İstek Yönetimi'
        ],
        image: 'https://hotelai.io/storage/hotelai-assistant.png'
      }
    },
    {
      icon: 'ri-line-chart-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Ranker',
      description: 'Otelinizin küresel seyahat acentelerindeki (OTA) performansını ve sıralamasını anlık takip ederek, görünürlüğünüzü artıracak stratejik iyileştirme önerileri sunan yapay zeka modülüdür.',
      link: '/#contact'
    },
    {
      icon: 'ri-exchange-dollar-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Competitor Analysis',
      description: 'Pazarın nabzını tutun. Belirlediğiniz rakiplerin fiyatlarını anlık olarak izler ve stratejinizi optimize etmeniz için gereken veriyi sağlar. Doğru fiyatlandırma ile doluluk oranınızı artırın.',
      link: '/#contact',
      detailContent: {
        title: 'Yapay Zeka Competitor Analysis',
        description: 'Pazarın nabzını tutun. Yapay Zeka Competitor Analysis, belirlediğiniz rakiplerin fiyatlarını anlık olarak izler ve stratejinizi optimize etmeniz için gereken veriyi sağlar. Doğru fiyatlandırma ile doluluk oranınızı artırın.',
        features: [
          'Anlık Fiyat Karşılaştırma',
          'Dinamik Fiyat Takibi',
          'Fiyat Değişim Alarmları',
          'Pazar Trend Analizi',
          'Stratejik Fiyat Önerileri'
        ],
        image: 'https://hotelai.io/storage/hotelai-rate-shopper.png'
      }
    },
    {
      icon: 'ri-bar-chart-box-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Regional Analysis',
      description: 'Yapay zeka ile gelecekteki doluluk oranlarını tahmin eden, uçuş verileri ve yerel etkinlikleri analiz ederek otelinizin en kârlı satış stratejilerini oluşturmanıza yardımcı olan öngörü modülüdür.',
      link: '/#contact',
      detailContent: {
        title: 'Regional Analysis',
        description: 'Bölgesel analizi yapın. Regional Analysis; uçuş verilerini, yerel etkinlikleri, tatilleri ve hava durumunu analiz ederek gelecekteki talebi tahmin eder. Kaynaklarınızı daha verimli kullanın ve gelirinizi maksimize edin.',
        features: [
          'Talep Tahminleme',
          'Uçuş Verileri Analizi',
          'Etkinlik ve Tatil Takibi',
          'Hava Durumu Etkisi',
          'Dinamik Fiyatlandırma Desteği'
        ],
        image: 'https://hotelai.io/storage/hotelai-demand-forecast.png'
      }
    },
    {
      icon: 'ri-star-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Reputation',
      description: 'Booking, Expedia, Airbnb, Google, Yandex, Tripadvisor misafir yorumlarını tek merkezden yapay zeka ile analiz edip yanıtlayarak otelinizin dijital itibarını ve online sıralamasını yükselten yönetim modülüdür. Aynı zamanda sıralamanızı yükseltmek için AI Destekli öneriler sunar.',
      link: '/#contact',
      detailContent: {
        title: 'Reputation',
        description: 'Dijital itibarınızı şansa bırakmayın. Reputation; Google, Booking, TripAdvisor ve Airbnb gibi platformlardaki yorumları tek bir yerden yönetmenizi sağlar. Duygu analizi ve yapay zeka destekli yanıt önerileriyle markanızı koruyun.',
        features: [
          'Yorum Konsolidasyonu',
          'Duygu Karakteri Analizi',
          'Yapay Zeka Destekli Yanıtlar',
          'Platform Bazlı Takip',
          'İtibar Puanı Geliştirme'
        ],
        image: 'https://hotelai.io/storage/hotelai-reputation.png'
      }
    },
    {
      icon: 'ri-chat-3-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Chatbot',
      description: 'Web sitenize gelen ziyaretçileri karşılar, sorularını yanıtlar ve onları rezervasyona yönlendirir. Çok dilli desteği ile küresel misafirlerinize anında hizmet sunar.',
      link: '/#contact',
      detailContent: {
        title: 'Chatbot',
        description: 'Web sitenize gelen ziyaretçileri karşılar, sorularını yanıtlar ve onları rezervasyona yönlendirir. Yapay Zeka Chatbot, çok dilli desteği ile küresel misafirlerinize 7/24 anında hizmet sunar.',
        features: [
          '7/24 Canlı Destek',
          'Çok Dilli İletişim',
          'Rezervasyon Yönlendirme',
          'Hızlı Entegrasyon',
          'Kişiselleştirilmiş Karşılama'
        ],
        image: 'https://hotelai.io/storage/app-panel.png'
      }
    },
    {
      icon: 'ri-share-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
      title: 'Yapay Zeka Social',
      description: 'Tüm sosyal medya etkileşimlerinizi ve platformlardaki görünürlüğünüzü yapay zeka ile yönetin. İçerik oluşturma ve yanıt verme süreçlerini otomatikleştirin, dijital dünyada fark yaratın.',
      link: '/#contact',
      detailContent: {
        title: 'Social',
        description: 'Tüm sosyal medya etkileşimlerinizi ve platformlardaki görünürlüğünüzü yapay zeka ile yönetin. İçerik oluşturma ve yanıt verme süreçlerini otomatikleştirin, dijital dünyada fark yaratın.',
        features: [
          'Sosyal Medya Yönetimi',
          'Yapay Zeka İçerik Üretimi',
          'Platform Bazlı Analitik',
          'Hızlı Yanıt Sistemi',
          'Görünürlük Artırıcı Öneriler'
        ],
        image: 'https://hotelai.io/storage/hotelai-social.png'
      }
    }
  ];

  const handleDetailClick = (app) => {
    if (app.detailContent) {
      setSelectedApp(selectedApp?.title === app.title ? null : app);
      if (selectedApp?.title !== app.title) {
        setTimeout(() => {
          const detailSection = document.getElementById('detail-section');
          if (detailSection) {
            detailSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
    } else {
      window.location.href = 'https://rjjgqc.readdy.co/app-detail';
    }
  };

  return (
    <div className="bg-white text-gray-900 font-sans antialiased overflow-x-hidden">
      {/* Header */}
      <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/95 backdrop-blur-md border-b border-gray-100'}`}>
        <nav className="px-6 md:px-12 py-4 max-w-7xl mx-auto flex items-center justify-between" aria-label="Ana navigasyon">
          <div className="flex items-center gap-3">
            <Link to="/" aria-label="Hotel Yapay Zeka Çözümleri Ana Sayfa">
              <img src="https://public.readdy.ai/ai/img_res/f353b4d7-dacd-40f7-a8e4-5449d615ae6c.png" alt="Hotel Yapay Zeka Çözümleri Logo" className="h-12 w-auto cursor-pointer" />
            </Link>
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium transition-colors whitespace-nowrap text-gray-900 hover:text-teal-600">Ana Sayfa</Link>
            <Link to="/apps" className="text-sm font-medium transition-colors whitespace-nowrap text-teal-600 font-bold">Uygulamalar</Link>
            <Link to="/#contact" className="text-sm font-medium transition-colors whitespace-nowrap text-gray-900 hover:text-teal-600">İletişim</Link>
          </div>

          <div className="flex gap-3">
            <Link to="/#contact" className="hidden sm:flex h-10 px-6 items-center justify-center rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-sm font-bold transition-all shadow-lg shadow-teal-600/30 whitespace-nowrap">
              <span>Ücretsiz Demo</span>
            </Link>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-gray-900 cursor-pointer" aria-label="Menüyü aç/kapat" aria-expanded={mobileMenuOpen}>
              <i className="ri-menu-line text-2xl text-gray-900"></i>
            </button>
          </div>
        </nav>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200/50 shadow-lg">
            <nav className="flex flex-col p-6 gap-4" aria-label="Mobil navigasyon">
              <Link to="/" className="text-left text-gray-900 hover:text-teal-600 font-medium" onClick={() => setMobileMenuOpen(false)}>Ana Sayfa</Link>
              <Link to="/apps" className="text-left text-teal-600 font-bold" onClick={() => setMobileMenuOpen(false)}>Uygulamalar</Link>
              <Link to="/#contact" className="text-left text-gray-900 hover:text-teal-600 font-medium" onClick={() => setMobileMenuOpen(false)}>İletişim</Link>
            </nav>
          </div>
        )}
      </header>

      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50 py-20 pt-32" aria-labelledby="apps-hero-title">
          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <div className="max-w-4xl mx-auto text-center">
              <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-wider text-white uppercase bg-teal-600 rounded-full">
                YAPAY ZEKA
              </span>
              <h1 id="apps-hero-title" className="text-4xl md:text-5xl font-black text-gray-900 mb-6 leading-tight">
                Oteliniz İçin <strong className="text-teal-600">Yapay Zeka</strong> Çözümleri
              </h1>
              <p className="text-lg text-gray-600 mb-10 leading-relaxed max-w-2xl mx-auto">
                <strong>Misafir deneyimini</strong> iyileştiren, <strong>operasyonel verimliliği</strong> artıran ve gelirinizi maksimize eden en gelişmiş Yapay Zeka modülleriyle tanışın.
              </p>
            </div>
          </div>
        </section>

        {/* Apps Grid Section */}
        <section className="py-20 bg-gray-50" aria-labelledby="apps-grid-title">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <h2 id="apps-grid-title" className="sr-only">Yapay Zeka Uygulamaları Listesi</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {apps.map((app, index) => (
                <article key={index} className="group bg-white rounded-2xl border border-gray-200 p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  <div className={`w-14 h-14 ${app.iconBg} rounded-xl flex items-center justify-center mb-6 ${app.iconColor} group-hover:scale-110 transition-transform`}>
                    <i className={`${app.icon} text-3xl`} aria-hidden="true"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-gray-900">{app.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-6">
                    {app.description}
                  </p>
                  <div className="flex items-center justify-between pt-6 border-t border-gray-50 mt-auto">
                    <button onClick={() => handleDetailClick(app)} className="inline-flex items-center font-bold text-teal-600 hover:text-teal-700 hover:gap-2 transition-all cursor-pointer">
                      Detayları İncele
                      <i className="ri-arrow-right-line ml-1 text-sm" aria-hidden="true"></i>
                    </button>
                  </div>
                </article>
              ))}
            </div>

            {/* Detail Content */}
            {selectedApp && selectedApp.detailContent && (
              <article id="detail-section" className="mt-16 bg-white rounded-2xl border border-gray-200 shadow-xl p-8 md:p-12">
                <div className="flex flex-col lg:flex-row items-center gap-16">
                  <div className="flex-1 space-y-8">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                      <span className="text-teal-600 border-b-4 border-teal-300">{selectedApp.detailContent.title}</span>
                    </h2>
                    <p className="text-lg text-gray-600 leading-relaxed">
                      {selectedApp.detailContent.description}
                    </p>
                    <ul className="space-y-4">
                      {selectedApp.detailContent.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center gap-3">
                          <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                            <i className="ri-check-line text-teal-600 text-sm"></i>
                          </div>
                          <span className="text-gray-900 font-medium">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <a href="/#contact" className="flex items-center font-bold text-teal-600 hover:text-teal-700 gap-2 group cursor-pointer">
                      Uygulamayı Keşfet
                      <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                    </a>
                  </div>

                  <div className="flex-1 w-full relative">
                    <div className="rounded-xl bg-white shadow-2xl border border-gray-200 overflow-hidden transform lg:rotate-1 hover:rotate-0 transition-all duration-500">
                      <div className="bg-gray-100 border-b border-gray-200 px-4 py-3 flex items-center gap-2">
                        <div className="flex gap-1.5">
                          <div className="w-3 h-3 rounded-full bg-red-400"></div>
                          <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                          <div className="w-3 h-3 rounded-full bg-green-400"></div>
                        </div>
                      </div>
                      <div>
                        <img src={selectedApp.detailContent.image} alt="Dashboard Preview" className="w-full h-auto" />
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            )}
          </div>
        </section>

        {/* Control Panel Section */}
        <section className="py-24 bg-white relative overflow-hidden" aria-labelledby="control-panel-title">
          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <div className="flex flex-col lg:flex-row items-center gap-16">
              <article className="flex-1 space-y-8">
                <h2 id="control-panel-title" className="text-3xl md:text-4xl font-black text-gray-900">
                  Yapay Zeka ile<br />
                  <strong className="text-teal-600 border-b-4 border-teal-300">Tüm Kontrol Sizde</strong>
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed">
                  <strong>Yapay Zeka:</strong> Operasyonel mükemmelliği ve <strong>misafir memnuniyetini</strong> yapay zeka ile birleştirerek, otelinizi akıllı ve yüksek kârlılığa sahip bir teknoloji ekosistemine dönüştürür.
                </p>
                <ul className="space-y-4">
                  <li className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-sm" aria-hidden="true"></i>
                    </div>
                    <span className="text-gray-900 font-medium">Anlık konuşma takibi ve müdahale imkanı</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-sm" aria-hidden="true"></i>
                    </div>
                    <span className="text-gray-900 font-medium">Rakip ve Bölge Analizleri</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-sm" aria-hidden="true"></i>
                    </div>
                    <span className="text-gray-900 font-medium">OTA Sıralama ve Performans Takibi</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-sm" aria-hidden="true"></i>
                    </div>
                    <span className="text-gray-900 font-medium">İtibar yönetimi ile yorumlara AI Destekli Cevaplar</span>
                  </li>
                </ul>
                <a href="#" className="flex items-center font-bold text-teal-600 hover:text-teal-700 gap-2 group cursor-pointer">
                  Paneli Keşfet
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                </a>
              </article>

              <figure className="flex-1 w-full relative">
                <div className="rounded-xl bg-white shadow-2xl border border-gray-200 overflow-hidden transform lg:rotate-1 hover:rotate-0 transition-all duration-500">
                  <div className="bg-gray-100 border-b border-gray-200 px-4 py-3 flex items-center gap-2">
                    <div className="flex gap-1.5">
                      <div className="w-3 h-3 rounded-full bg-red-400"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                      <div className="w-3 h-3 rounded-full bg-green-400"></div>
                    </div>
                  </div>
                  <div>
                    <img src="https://hotelai.io/storage/app-panel.png" alt="Hotel Yapay Zeka Dashboard - Otel yönetim paneli ekran görüntüsü" title="Yapay Zeka Dashboard" className="w-full h-auto" loading="lazy" />
                  </div>
                </div>
                <figcaption className="sr-only">Hotel Yapay Zeka yönetim paneli arayüzü</figcaption>
              </figure>
            </div>
          </div>
        </section>

        {/* Meet Yapay Zeka Section */}
        <section className="py-20 bg-teal-600 text-white overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-teal-500/20 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal-700/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
          
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
            <div className="w-24 h-24 mx-auto mb-6 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20">
              <img src="https://hotelai.io/storage/favicon.ico" alt="Yapay Zeka" className="w-12 h-12" />
            </div>
            <h2 className="text-3xl md:text-5xl font-black mb-6">Yapay Zeka ile Tanışın</h2>
            <p className="text-lg md:text-xl text-white leading-relaxed mx-auto mb-10">
              7/24 çalışan, hiç yorulmayan ve sürekli öğrenen akıllı asistanınız. Misafirlerinizin tüm taleplerini anında karşılar, personel yükünüzü azaltır ve hizmet kalitenizi artırır.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-left">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10">
                <h3 className="font-bold text-xl mb-2 text-white">Sürekli Öğrenir</h3>
                <p className="text-sm text-white/80">
                  Otelinizdeki değişiklikleri ve yeni hizmetleri anında öğrenir ve kendini geliştir.
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10">
                <h3 className="font-bold text-xl mb-2 text-white">Asla Uyumaz</h3>
                <p className="text-sm text-white/80">
                  Gece vardiyasında resepsiyonistin en büyük yardımcısı ve arkadaşı olur.
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10">
                <h3 className="font-bold text-xl mb-2 text-white">Sadıktır</h3>
                <p className="text-sm text-white/80">
                  Marka dilinize uygun konuşur, asla kaba davranmaz. Sizin için tüm süreci yönetir.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 border-t border-gray-100" aria-labelledby="cta-title">
          <div className="container mx-auto px-4 max-w-4xl text-center">
            <h2 id="cta-title" className="text-3xl font-bold text-gray-900 mb-6">Hemen Dijital Dönüşümü Başlatın</h2>
            <p className="text-gray-600 text-lg mb-10">Otelinizin ihtiyaçlarına en uygun <strong>yapay zeka çözümünü</strong> birlikte planlayalım. Daha fazla bilgi için ekibimizle iletişime geçin.</p>
            <Link to="/#contact" className="inline-flex items-center gap-3 px-10 py-5 bg-gray-900 text-white rounded-2xl font-black text-lg hover:scale-105 transition-transform shadow-xl">
              <i className="ri-message-line" aria-hidden="true"></i>
              Bilgi Almak İçin Yazın
            </Link>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-teal-900 text-white pt-20 pb-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
            <div className="col-span-1">
              <div className="flex items-center gap-2 mb-6">
                <img src="https://public.readdy.ai/ai/img_res/f353b4d7-dacd-40f7-a8e4-5449d615ae6c.png" alt="Hotel Yapay Zeka Çözümleri Logo" className="h-10 w-auto" />
              </div>
              <p className="text-teal-200 text-sm leading-relaxed mb-6">
                Oteller için geliştirilmiş yeni nesil <strong>yapay zeka asistanı</strong>. Misafir memnuniyetini artırın, maliyetleri düşürün.
              </p>
            </div>

            <div>
              <h4 className="font-bold mb-6 text-lg"><a href="#" className="hover:text-teal-300 transition-colors">Şirket</a></h4>
              <ul className="space-y-3 text-sm text-teal-200">
                <li><a href="https://yapayzekacozumleri.com/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Hakkımızda</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Gizlilik Politikası</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Hizmet Şartları</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">KVKK</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-6 text-lg"><a href="/#contact" className="hover:text-teal-300 transition-colors">İletişim</a></h4>
              <address className="not-italic">
                <ul className="space-y-3 text-sm text-teal-200">
                  <li className="flex items-center gap-2">
                    <i className="ri-mail-line text-teal-400" aria-hidden="true"></i>
                    <a href="mailto:yapayzekacozumlerim@gmail.com" className="hover:text-white transition-colors cursor-pointer">
                      yapayzekacozumlerim@gmail.com
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-global-line text-teal-400" aria-hidden="true"></i>
                    <a href="https://yapayzekacozumleri.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                      yapayzekacozumleri.com
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-global-line text-teal-400" aria-hidden="true"></i>
                    <a href="https://hotelyapayzekacozumleri.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                      hotelyapayzekacozumleri.com
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-phone-line text-teal-400" aria-hidden="true"></i>
                    <a href="tel:+905542367386" className="hover:text-white transition-colors cursor-pointer">
                      0 554 236 73 86
                    </a>
                  </li>
                </ul>
              </address>
            </div>
          </div>

          <div className="border-t border-teal-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-teal-300 text-sm">
              © 2025 Hotel Yapay Zeka Çözümleri. Tüm hakları saklıdır.
            </p>
            <div className="flex gap-6 text-sm text-teal-300">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
